<template>
  <div class="honor-buy">
    <navbar title="信用购领豪礼" show-home ref="navbar" />
    <div class="banner">
      <swiper :img-list="banners" />
    </div>
    <div class="level-navs">
      <level-navs ref="levelNavs" :nav-list="navList" :nav-height="navbarHeight" />
    </div>
  </div>
</template>

<script>
import api from '../../utils/api'
import Swiper from '../../components/swiper'
import Navbar from '../../components/NavBar'
import LevelNavs from '../../components/honorBuy/hornorBuyLevelNav'
export default {
  name: 'hornorBuy',
  components: {
    Navbar,
    Swiper,
    LevelNavs
  },
  data () {
    return {
      banners: [],
      navbarHeight: 44,
      navList: []
    }
  },
  mounted () {
    this.navbarHeight = this.$refs.navbar.navbarHeight
    this.getBannerList()
    this.getNavList().then(() => {
      this.$refs.levelNavs.getContList(this.navList[0].id)
      this.$refs.levelNavs.getCatPriceList(this.navList[0].id)
    })
  },
  methods: {
    async getBannerList () {
      const data = await api.getLocationCodingHandler('hornorbuy-1')
      if (data) {
        this.banners = data
      }
    },
    async getNavList () {
      const res = await this.$axios.get('api/business/list')
      if (res.status === 200) {
        const { code, msg, data } = res.data
        if (code === 0) {
          this.navList = data
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.hornor-buy {
  .banner {
    width: 100%;
    min-height: 3.6rem;
  }
}
</style>
